import { ShieldCheck, Sparkles, MessageSquare, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const icons = [ShieldCheck, Sparkles, MessageSquare, MapPin];

const TrustBar = () => {
  const { t } = useLanguage();
  return (
    <section className="relative border-y border-white/10 bg-[#0d0d0d]" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {t.trust.map((item, i) => {
          const Icon = icons[i];
          return (
            <div
              key={item}
              className="flex items-center gap-3 text-white/85"
              data-testid={`trust-item-${i}`}
            >
              <span className="w-10 h-10 rounded-full bg-[#e10600]/10 border border-[#e10600]/30 flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-[#e10600]" />
              </span>
              <span className="text-sm md:text-[15px] font-semibold leading-snug">{item}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBar;
